import React from "react";
import PropTypes from "prop-types";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { AppFieldWithLabelAndError } from "./AppTypography";

const AppPhoneNumberInput = ({
  label,
  mandatory,
  error,
  value,
  keyVal,
  placeHolder,
  handleValues,
  inputProps={},
}) => {
  return (
    <AppFieldWithLabelAndError label={label} required={mandatory} error={error}>
      <div dir="ltr">
        <PhoneInput
          international
          countryCallingCodeEditable={false}
          defaultCountry="AE"
          countries={["AE"]}
          value={value || null}
          onChange={(val) => handleValues(keyVal, val)}
          placeholder={placeHolder}
          className={`
            app-phone-input flex items-center rounded-xl border bg-white px-3 py-2
            transition focus-within:ring-2 focus-within:ring-inset focus-within:ring-blue-500 focus-within:border-blue-500
            ${error ? "border-red-500" : "border-gray-300"}
          `}
          numberInputProps={{
            className:
              "w-full border-none bg-transparent text-sm text-gray-700 placeholder-gray-400 focus:outline-none",
          }}
          {...inputProps}
        />
        </div>
    </AppFieldWithLabelAndError>
  );
};

AppPhoneNumberInput.propTypes = {
  mandatory: PropTypes.bool,
  error: PropTypes.string,
  handleValues: PropTypes.func,
  placeHolder: PropTypes.string,
  label: PropTypes.string,
  keyVal: PropTypes.string,
  value: PropTypes.string,
};

export default AppPhoneNumberInput;

